import React, { useEffect } from 'react'
import { pageTitle } from '../../helper'
import Portfolio from '../Portfolio';
import Slider from 'react-slick';
import { Icon } from '@iconify/react';
import Card from '../Card'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
// import PricingTableList from '../PricingTable/PricingTableList'
// import PortfolioSlider2 from '../Slider/PortfolioSlider2';
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

const portfolioData = [
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/portfolio_31.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/portfolio_32.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/portfolio_33.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/portfolio_34.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/portfolio_35.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/portfolio_36.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/portfolio_37.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/portfolio_38.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/portfolio_39.png',
  },
];



const PortfolioSlider2 = () => {
  /** Slider Settings **/
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="bi:arrow-left" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-next slick-arrow' +
        (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="bi:arrow-right" />
    </div>
  );
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    // Added autoplay settings
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <Slider {...settings} className="cs-gap-12 cs-arrow_style4">
      {portfolioData.map((item, index) => (
        <Div key={index}>
          <Portfolio
            title={item.title}
            subtitle={item.subtitle}
            href={item.href}
            src={item.src}
            variant="cs-style1 cs-type2 cs-size3"
          />
        </Div>
      ))}
    </Slider>
  );
}



export default function ServicesPage() {
  pageTitle('Service');
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <PageHeading
        title='Services'
        bgSrc='images/service_hero_bg.jpeg'
        pageLinkText='Services'
      />
      <Spacing lg='150' md='80' />
      <Div className='cs-shape_wrap_4'>
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title='Solutions Tailored for You'
                subtitle='The Magic We Deliver'
              />
              <Spacing lg='90' md='45' />
            </Div>
            <Div className='col-xl-8'>
              <Div className='row'>
                <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
                <Div className='col-lg-3 col-sm-6'>
                  <Card
                    title='Crafting Brands'
                    link='/crafting-brands'
                    src='/images/service_1.png'
                    alt='Service'
                  />
                  <Spacing lg='0' md='30' />
                </Div>
                <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
                <Div className='col-lg-3 col-sm-6'>
                  <Card
                    title='Building Tech'
                    link='/BuildingTech'
                    src='/images/service_4.jpeg'
                    alt='Service'
                  />
                  <Spacing lg='0' md='30' />
                </Div>
                <Div className='col-lg-3 col-sm-6'>
                  <Card
                    title='Creating Content'
                    link='/creatingcontent'
                    src='/images/service_3.png'
                    alt='Service'
                  />
                  <Spacing lg='0' md='30' />
                </Div>
                <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
                <Div className='col-lg-3 col-sm-6'>
                  <Card
                    title='Designing Experiences'
                    link='/designing-experiences'
                    src='/images/service_2.png'
                    alt='Service'
                  />
                  <Spacing lg='0' md='30' />
                </Div>
                <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
                <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
                <Div className='col-lg-3 col-sm-6'>
                  <Card
                    title='SEO & Lead Acceleration'
                    link='/seo-lead-acceleration'
                    src='/images/service_5.jpeg'
                    alt='Service'
                  />
                  <Spacing lg='0' md='30' />
                </Div>
                <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
                <Div className='col-lg-3 col-sm-6'>
                  <Card
                    title='Creators Connect'
                    link='/creators-connect'
                    src='/images/service_6.jpeg'
                    alt='Service'
                  />
                  <Spacing lg='0' md='30' />
                </Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg='150' md='80' />


      <Spacing lg="90" md="70" />
      <PortfolioSlider2 />
      {/* <Div className="container">
        <SectionHeading
          title='Providing best <br/>pricing for client'
          subtitle='Pricing & Packaging'
        />
        <Spacing lg='85' md='40' />
        <PricingTableList />
      </Div> */}
      <Spacing lg='125' md='55' />
      <TestimonialSlider />
      <Spacing lg='150' md='80' />
      <Div className="container">
        <Cta
          title="Let&apos;s Build The <br />Next Big Thing Together! "
          btnText='Your Next Big Move Starts Here!'
          btnLink='/contact'
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}
